import React from "react";

const MaximumBonusAmount: React.FunctionComponent = () => {
  const currentDate = new Date();
  const targetDate = new Date("2023-12-30");

  if (currentDate < targetDate) {
    // Avant le 30 décembre 2023
    return <span>25</span>;
  } else {
    // Après le 30 décembre 2023
    return <span>50</span>;
  }
};

export default MaximumBonusAmount;
